export default "__VITE_ASSET__71b0c364__"